import { render, staticRenderFns } from "./creatname.vue?vue&type=template&id=54cf290c&scoped=true&"
import script from "./creatname.vue?vue&type=script&lang=js&"
export * from "./creatname.vue?vue&type=script&lang=js&"
import style0 from "./creatname.vue?vue&type=style&index=0&id=54cf290c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf290c",
  null
  
)

export default component.exports